export default __webpack_public_path__ + "static/media/white-polyline-measure-icon.3d6bd196.svg";